// component
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: 'Insured',
    path: '/form/insured',
  },
  {
    title: 'Locations',
    path: '/form/locations',
  },
  {
    title: 'Coverage And Classes',
    path: '/form/coverage-and-classes',
  },
  {
    title: 'Owners / Officers',
    path: '/form/owners-officers',
  },
  {
    title: 'Current Coverage',
    path: '/form/current-coverage',
  },
  {
    title: 'Additional Questions',
    path: '/form/additional-questions',
  },
  {
    title: 'Attachments',
    path: '/form/attachments',
    icon: getIcon('ion:document-attach-outline'),
  },
  {
    title: 'Policy Ownership And Fraud Statement',
    path: '/form/policy-ownership-and-fraud-statement',
    icon: getIcon('ion:document-text-outline'),
  },
];

export default navConfig;
